module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"readHelp":"Ouvrez un message d\u0027aide","closeHelp":"Fermez le message d\u0027aide","readDoc":"Consultez la documentation"},"en":{"readHelp":"Open a help message","closeHelp":"Close the help message","readDoc":"Read the documentation"}}')
  delete Component.options._Ctor
}
